export default __webpack_public_path__ + "static/ANC Brokerage_logo-6f2c1253ad0f6dac27f71ba7aee59978.png";